// GamePopup.jsx
// Generic modal shell shared by every room popup. Matches room.php's two
// modal skins: `.modal-content` (small_modal.png — clue/learning/hint) and
// `.modal-content1` (big_modal.png — the five activity popups).
import React from 'react';
import './GamePopup.css';

function GamePopup({ open, onClose, size = 'small', ariaLabel, closeButton = true, children, testId }) {
  if (!open) return null;

  return (
    <div className="escape-popup-backdrop">
      <div
        className={`escape-popup-content escape-popup-content--${size}`}
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        data-testid={testId}
      >
        {closeButton && (
          <button
            type="button"
            className="escape-popup-close"
            onClick={onClose}
            aria-label="Close"
            data-testid="escape-popup-close"
          >
            X
          </button>
        )}
        {children}
      </div>
    </div>
  );
}

export default GamePopup;
